<div
  class="loading-state"
  role="progressbar"
  aria-busy="true"
  [attr.aria-label]="label">
  <div class="loading-content">
    <div class="loading-logo">
      <b3-logo
        class="loading-logo__asset"
        size="md"
        color="white"
        aria-label="B3">
      </b3-logo>
      <span class="loading-logo__label">{{ label }}</span>
    </div>

    <div class="loading-dots" aria-hidden="true">
      <span class="loading-dots__dot loading-dots__dot--1"></span>
      <span class="loading-dots__dot loading-dots__dot--2"></span>
      <span class="loading-dots__dot loading-dots__dot--3"></span>
    </div>
  </div>
</div>
